module.exports = __webpack_public_path__ + "3cf950a8c5e6f3f2723dac7b0302a2e7.MP3";